export const environment = {
    production: true,
    apiUrl: '/api/',
    siteKey: 'FCML18O24AN9OTFE'
};
